import { uniq, omit, flatten, compact } from 'lodash-es'
import { authorRoleProperties } from '#entities/lib/editor/properties_per_subtype'
import { getEntitiesAttributesByUris, type SerializedEntity } from '#entities/lib/entities'
import type { EntityUri, PropertyUri } from '#server/types/entity'
import { getCurrentLang } from '#user/lib/i18n'

export async function getPublishersByUrisFromEditions (editions: SerializedEntity[]) {
  const publishersUris = getPublishersUrisFromEditions(editions)
  const { entities } = await getEntitiesAttributesByUris({
    uris: publishersUris,
    // info is necessary to get the type, and generate publisher URI link without "wdt:P921-" prefix
    attributes: [ 'info', 'labels' ],
    lang: getCurrentLang(),
  })
  return entities
}

function getPublishersUrisFromEditions (editions: SerializedEntity[]) {
  return uniq(compact(flatten(editions.map(edition => {
    return findFirstClaimValue(edition, 'wdt:P123')
  })))) as EntityUri[]
}

const omittedProps: PropertyUri[] = [ ...authorRoleProperties, 'wdt:P1680' ]
export function omitNonInfoboxClaims (claims: SerializedEntity['claims']) {
  return omitClaims(claims, omittedProps)
}

export function omitClaims (claims: SerializedEntity['claims'], properties: (PropertyUri | PropertyUri[])[]) {
  return omit(claims, properties.flat())
}

function findFirstClaimValue (entity: SerializedEntity, prop: PropertyUri) {
  const values = entity?.claims[prop]
  if (!values || !values[0]) return
  return values[0]
}
